
import { useEffect, useState } from 'react';
import { useAffiliateInfo } from './useAffiliate';
import { resolveReferralCode } from '@/utils/referralUtils';
import { affiliateService } from '@/services/affiliateService';
import { AppSettingsService } from '@/services/app-settings-service';

export const useAiPropRefLink = () => {
  const [refLink, setRefLink] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  
  useEffect(() => {
    const fetchRefLink = async () => {
      try {
        setIsLoading(true);
        
        // Check if user came through an affiliate referral
        const referralCode = resolveReferralCode();
        
        if (referralCode) {
          // If yes, get that affiliate's AI Prop link
          const affiliateInfo = await affiliateService.getAffiliateByReferralCode(referralCode);
          
          if (affiliateInfo?.ai_prop_ref_link) {
            setRefLink(affiliateInfo.ai_prop_ref_link);
            setIsLoading(false);
            return;
          }
        }
        
        // If not from a referral or affiliate doesn't have an AI Prop link, 
        // get the default link from database
        const defaultLink = await AppSettingsService.getAiPropDefaultLink();
        setRefLink(defaultLink);
      } catch (error) {
        console.error("Error fetching AI Prop referral link:", error);
        // Fallback to hardcoded value if database fails
        setRefLink('https://aiprop.com/default-ref');
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchRefLink();
  }, []);
  
  return { refLink, isLoading };
};
